import FtrCopyrightText from './FtrCopyrightText';
export default FtrCopyrightText;